export default "__VITE_ASSET__BwvMnp4i__"